import GuideDetailsContainer from './GuideDetailsContainer';

export default GuideDetailsContainer;
